import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { queryClient } from '@/lib/queryClient';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from 'sonner';
import { useOrgDefaultTheme } from '@/hooks/useOrgDefaultTheme';
import type { ReactNode } from 'react';

function OrgThemeSync({ children }: { children: ReactNode }) {
  useOrgDefaultTheme();
  return <>{children}</>;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem={false}
        storageKey="pwa-atkomst-theme"
      >
        <AuthProvider>
          <OrgThemeSync>
            {children}
          </OrgThemeSync>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
